import { Boundaries } from "@planzone/core";
import { ExportBiRunStatus } from "@planzone/dto";
import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { State } from "./types";

function notifyFinishedRun(
  state: State,
  { run }: Boundaries["retrieveExportBiRun"]["success"],
): State {
  switch (run.status) {
    case ExportBiRunStatus.COMPLETED:
      return {
        ...state,
        queue: updateNotification(
          {
            key: "exportBiRun",
            flags: ["success"],
            args: { success: "true" },
          },
          state.queue,
        ),
      };
    case ExportBiRunStatus.PARTIAL:
      return {
        ...state,
        queue: updateNotification(
          {
            key: "exportBiRun",
            flags: ["partial"],
            args: { failure: "true" },
          },
          state.queue,
        ),
      };
    case ExportBiRunStatus.FAILED:
      return {
        ...state,
        queue: updateNotification(
          {
            key: "exportBiRun",
            flags: ["failure"],
            args: { failure: "true" },
          },
          state.queue,
        ),
      };
    default:
      return state;
  }
}

const reduceExportBiRunNotificationState = createStateReducer(initialState, {
  [events.requestExportBiRunFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "exportBiRun",
        flags: ["requestFailure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
  [events.retrieveExportBiRunSucceeded]: notifyFinishedRun,
  [events.retrieveExportBiRunFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "exportBiRun",
        flags: ["retrieveFailure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceExportBiRunNotificationState };
